import { useRef, useState, useEffect } from 'react';

import './Home.css';
import InnerImg from '../../../Assets/indexImg.jpg';
import { useTypewriter } from 'react-simple-typewriter';
import Bank from './Assets/bank.png';
import Payment from './Assets/payment (1).png';
import Agreement from './Assets/agreement.png';
import Certificate from './Assets/certificate.png';
import Travel from '../Home/Assets/ticket.svg';
import Insurance from '../../../Assets/icons/courier.svg';
import { ThirdSection } from '../ThirdSection/ThirdSection';
import { FourthSection } from '../FourthSection/FourthSection';
import { SevenSection } from '../SevenSection/SevenSection';
import { TenthSection } from '../TenthSection/TenthSection';
import RoeSection from '../RoeSection/RoeSection';
import { HomePageData } from '../../Data/HomePageData';
import { motion } from "framer-motion";
import { GetTranlatedValue, GetWordDictonary } from '../../Data/LanguageContext';

import CashWithdrawalIcon from '../../../Assets/services/cash-withdraw-svgrepo-com.svg';
import UPICashWithdrawalIcon from '../../../Assets/services/qr-code-svgrepo-com.svg';
import MoneyTransferIcon from '../../../Assets/services/money-send-svgrepo-com.svg';
import MATMIcon from '../../../Assets/services/atm-deposit-svgrepo-com.svg';
import CashDepositIcon from '../../../Assets/services/cash-withdraw-svgrepo-com.svg';
import CourierServiceIcon from '../../../Assets/services/delivery-svgrepo-com.svg';
import DigitalGoldIcon from '../../../Assets/services/gold-ingot-gold-svgrepo-com.svg';
import CreditCardIcon from '../../../Assets/services/icon_credit_Card_5bea610844.svg';
import MobileRechargeIcon from '../../../Assets/services/icon_mobile_Prepaid_75d60071ff.svg';
import DTHRechargeIcon from '../../../Assets/services/icon_dth_5f9878e6e1.svg';
import ElectricityBillIcon from '../../../Assets/services/icon_electricity_7b87e6d717.svg';
import LandlineIcon from '../../../Assets/services/home-phone-svgrepo-com.svg';
import BroadbandIcon from '../../../Assets/services/router-svgrepo-com.svg';
import LoanRepaymentIcon from '../../../Assets/services/loanreplayment.svg';
import InsurancePremiumIcon from '../../../Assets/services/icon_insurance_d4940cd803.svg';
import MunicipalPaymentIcon from '../../../Assets/services/icon_municipal_Taxes_810ee731e1.svg';
import WaterBillIcon from '../../../Assets/services/icon_water_d2c43997ba.svg';
import BusBookingIcon from '../../../Assets/services/bus-transportvehicle-svgrepo-com.svg';
import HotelBookingIcon from '../../../Assets/services/hotel-mobile-svgrepo-com.svg';
import FlightBookingIcon from '../../../Assets/services/flight-plane-svgrepo-com.svg';
import TrainTicketBookingIcon from '../../../Assets/services/train-ticket-svgrepo-com.svg';
import GSTReturnFilingIcon from '../../../Assets/services/task-svgrepo-com.svg';
import IncomeTaxReturnIcon from '../../../Assets/services/task-svgrepo-com.svg';
import PersonalLoanIcon from '../../../Assets/services/dollar-finance-money-20-svgrepo-com.svg';
import BusinessLoanIcon from '../../../Assets/services/business-svgrepo-com.svg';
import HomeLoanIcon from '../../../Assets/services/mortgage-svgrepo-com.svg';
import TestimonialSection from '../Testimonialsection/Testimonialsection';
import play from "../../../Assets/play.png";
import { platformDemoData, testimonials } from '../Testimonialsection/data';
import AwardContainer from '../../Awards';
import MediaCoverage from '../MediaCoverage/Mediacoverage';
import MediaCentreSummary from '../../MediaCentre/MediaCentreSummary';
import BharatConnectLogo from '../../../svg/Bharat Connect Primary Logo_SVG.svg';


const Home = () => {
  const thirdSectionRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToRef = (ref) => {
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: 'smooth',
    });
  };

  const [text] = useTypewriter({
    words: GetWordDictonary(),
    loop: true,
    typeSpeed: 120,
    deleteSpeed: 50,
  });


  const FirstServices = [
    { id: 1, name: "Cash Withdrawal", icon: CashWithdrawalIcon },
    { id: 2, name: "UPI Cash Withdrawal", icon: UPICashWithdrawalIcon },
    { id: 3, name: "Money Transfer", icon: MoneyTransferIcon },
    { id: 4, name: "MATM", icon: MATMIcon },
    { id: 5, name: "Cash Deposit", icon: CashDepositIcon },
    { id: 6, name: "Courier Service", icon: CourierServiceIcon },
    { id: 7, name: "Digital Gold", icon: DigitalGoldIcon },
  ];

  const SecondeService = [
    { id: 1, name: "Credit Card", icon: CreditCardIcon },
    { id: 2, name: "Mobile Recharge", icon: MobileRechargeIcon },
    { id: 3, name: "DTH Recharge", icon: DTHRechargeIcon },
    { id: 4, name: "Electricity Bill", icon: ElectricityBillIcon },
    { id: 5, name: "Landline", icon: LandlineIcon },
    { id: 6, name: "Broadband", icon: BroadbandIcon },
    { id: 7, name: "Loan Repayment", icon: LoanRepaymentIcon },
    { id: 8, name: "Insurance Premium", icon: InsurancePremiumIcon },
    { id: 9, name: "Municipal Payment", icon: MunicipalPaymentIcon },
    { id: 10, name: "Water Bill", icon: WaterBillIcon },
  ];

  const ThirdService = [
    { id: 1, name: "Bus Booking", icon: BusBookingIcon },
    { id: 2, name: "Hotel Booking", icon: HotelBookingIcon },
    { id: 3, name: "Flight Booking", icon: FlightBookingIcon },
    { id: 4, name: "Train Ticket Booking", icon: TrainTicketBookingIcon },
    { id: 6, name: "GST Return Filing", icon: GSTReturnFilingIcon },
    { id: 7, name: "Income Tax Return", icon: IncomeTaxReturnIcon },
    { id: 8, name: "Personal Loan", icon: PersonalLoanIcon },
    { id: 9, name: "Business Loan", icon: BusinessLoanIcon },
    { id: 10, name: "Home Loan", icon: HomeLoanIcon },
  ];

  return (
    <>
      <div className="home-container">
        <div className="background-circle d-flex align-items-center">
          <div className="container position-relative" style={{ paddingTop: 75 }}>
            <div className="row m-0 d-flex align-items-center large-devices">
              <div className="col-lg-6 col-md-12 col-sm-12 col-12 p-0">
                <div className="d-flex flex-column csp-main-heading-h1">
                  <div className="m-0 p-0">
                    <div className="home-csp-heading">
                      <h1>
                        {GetTranlatedValue(HomePageData?.FIRSTSECTION?.mainheading)}
                        <br />
                        {GetTranlatedValue(HomePageData?.FIRSTSECTION?.mainheading2)}
                      </h1>
                    </div>
                    <div className="typewriter_heading d-flex align-items-center text">
                      <h1>{text}</h1>
                    </div>
                  </div>
                  <p className="mt-4" style={{ color: '#212529' }}>
                    {GetTranlatedValue(HomePageData?.FIRSTSECTION?.mainheading1)}
                  </p>
                  <ul className="p-0" style={{ listStyleType: 'none' }}>
                    {HomePageData.FIRSTSECTION.homelist.map((sec, i) => (
                      <li
                        key={i}
                        className="d-flex align-items-center"
                        style={{ color: '#00B087', gap: 20, fontWeight: 600 }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-check-circle"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                          <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"></path>
                        </svg>
                        {GetTranlatedValue(sec.title)}
                      </li>
                    ))}
                  </ul>
                  <div className="responsive-btn d-flex gap-4">
                    <a
                      href={`${window.location.origin}/version2/auth/login`}
                      style={{ textDecoration: 'none', backgroundColor: '#2c5363' }}
                      className="btn mb-2 csp-home-btn d-flex align-items-center px-3 px-lg-4 rounded-pill"

                    >

                      {GetTranlatedValue(HomePageData?.FIRSTSECTION?.getstarted)}
                      <span className="d-flex home-btn-arrow" style={{ transitionDuration: '0.3s' }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="currentColor"
                          className="bi bi-arrow-right-short"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                    <a
                      title='Download Application'
                      href={'https://play.google.com/store/apps/details?id=com.cspindianetwork.app&pcampaignid=web_share'}
                      style={{ textDecoration: 'none', backgroundColor: "#fff", border: "1px solid #2c5363" }}
                      className="btn mb-2 csp-home-btn d-flex align-items-center px-3 px-lg-4 rounded-pill gap-2"
                    >
                      <img src={play} style={{ height: 20, width: 20 }}></img>
                      <div style={{ display: 'flex', flexDirection: "column", alignItems: "start" }}>
                        <span style={{ color: "#000", fontSize: "16px" }}>Google Play</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center home_rotate_container justify-content-center">
                <div id="rotating_container">
                  {[Bank, Payment, Agreement, Certificate, Travel, Insurance].map((img, i) => (
                    <div className="home-circle-item" style={{ '--d': `${-i * 9}s` }} key={i}>
                      <img className="circle_imgs" src={img} alt={`icon-${i}`} />
                    </div>
                  ))}
                </div>
                <img
                  className="home_bg_circle m-0 p-0"
                  src={InnerImg}
                  alt="inner"
                  fetchPriority="high"
                  loading="eager"
                  style={{ borderRadius: '100%' }}
                />
              </div>
            </div>
            <div className="scroll-down-btn">
              <button
                className="btn border-0 shadow-none d-flex align-items-center"
                style={{ gap: 10 }}
                onClick={() => scrollToRef(thirdSectionRef)}
              >
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                    <circle cx="9.5" cy="9.5" r="9.5" fill="#efefef"></circle>
                    <svg x="6" y="5" xmlns="http://www.w3.org/2000/svg" width="6.519" height="7.838" viewBox="0 0 6.519 7.838">
                      <g transform="translate(6.519) rotate(90)">
                        <path
                          d="M5.682,3.872H.5a.444.444,0,0,1-.5-.5c0-.092,0-.184,0-.275a.42.42,0,0,1,.451-.448H5.664C5.637,2.618,5.62,2.6,5.6,2.58L4.062,1.037a.444.444,0,0,1,0-.7C4.13.27,4.2.2,4.264.137a.427.427,0,0,1,.628,0Q6.3,1.54,7.7,2.945a.43.43,0,0,1-.02.65L5.11,6.164,4.9,6.369a.433.433,0,0,1-.656,0l-.206-.205a.427.427,0,0,1,0-.654L5.616,3.942c.019-.019.036-.039.066-.07"
                          fill="#b1b1b1"
                        ></path>
                      </g>
                    </svg>
                  </svg>
                </span>
                <span style={{ fontWeight: 500, color: '#a9a9a9' }}>
                  {GetTranlatedValue(HomePageData?.FIRSTSECTION?.scrolldown)}
                </span>
              </button>
            </div>
            <MediaCentreSummary />

          </div>

        </div>

      </div>

      <ThirdSection ref={thirdSectionRef} />
      <div className='bg-white'>
        <div className='text-center pt-4'>
          <h3 className='fw-bold mb-3' style={{ fontSize: '3rem', fontWeight: "bold", color: "#283646" }}>
            <span style={{ color: "rgb(22, 178, 135)" }}>60<sup>+</sup></span> Services
          </h3>
        </div>
        <div className="infinite-queue">
          <motion.div
            className="queue-track"
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              repeat: Infinity,
              ease: "linear",
              duration: 40,
            }}
          >
            {[...FirstServices, ...FirstServices].map((item, i) => (
              <div
                key={i}
                className="queue-item"
                style={{
                  margin: 10,
                  height: "8rem",
                  width: "20rem",
                  borderRadius: 12,
                  border: '1px solid rgb(44, 83, 99)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                  flexDirection: "column",
                }}
              >
                <img
                  src={item.icon}
                  alt={`${item.name}-icon`}
                  style={{ width: '2rem', height: '2rem', objectFit: 'contain' }}
                />
                <p style={{ fontSize: "1rem", fontWeight: 400, color: "rgb(44, 83, 99)", marginBottom: 0 }}>
                  {item.name}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
        <div className="infinite-queue">
          <motion.div
            className="queue-track"
            animate={{ x: ["-50%", "0%"] }}
            transition={{
              repeat: Infinity,
              ease: "linear",
              duration: 40,
            }}
          >
            {[...SecondeService, ...SecondeService].map((item, i) => (
              <div
                key={i}
                className="queue-item"
                style={{
                  margin: 10,
                  height: "8rem",
                  width: "20rem",
                  borderRadius: 12,
                  border: '1px solid gray',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                  flexDirection: "column",
                }}
              >
                <img
                  src={item.icon}
                  alt={`${item.name}-icon`}
                  style={{ width: '2.5rem', height: '2.5rem', objectFit: 'contain' }}
                />
                <p style={{ fontSize: "1rem", fontWeight: 400, color: "black", marginBottom: 0 }}>
                  {item.name}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
        <div className="infinite-queue pb-4">
          <motion.div
            className="queue-track"
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              repeat: Infinity,
              ease: "linear",
              duration: 40,
            }}
          >
            {[...ThirdService, ...ThirdService].map((item, i) => (
              <div
                key={i}
                className="queue-item"
                style={{
                  margin: 10,
                  height: "8rem",
                  width: "20rem",
                  borderRadius: 12,
                  border: '1px solid gray',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                  flexDirection: "column",
                }}
              >
                <img
                  src={item.icon}
                  alt={`${item.name}-icon`}
                  style={{ width: '2.5rem', height: '2.5rem', objectFit: 'contain' }}
                />
                <p style={{ fontSize: "1rem", fontWeight: 400, color: "black", marginBottom: 0 }}>
                  {item.name}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
        <div className='py-5 bg-white'>
          <div className='container'>
            <div
              className='d-flex flex-column flex-md-row align-items-center justify-content-between p-4 p-md-5 rounded-3'
              style={{
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
                gap: "24px"
              }}
            >
              <div className='text-center text-md-start'>
                <h3
                  className='fw-bold mb-2'
                  style={{
                    fontSize: isMobile ? '1.2rem' : '2rem',
                    color: "#37546d",
                    lineHeight: 1.3,
                    margin: 0
                  }}
                >
                  Now We are an agent institution of{" "}
                  <span style={{ color: "rgb(22, 178, 135)" }}>Bharat Connect</span>
                </h3>
                <p className='text-muted mb-0 mt-2' style={{ fontSize: isMobile ? '0.85rem' : '0.95rem' }}>
                  Empowering communities with seamless, secure utility payment and billing services.
                </p>
              </div>
              <div className='d-flex justify-content-center align-items-center' style={{ minWidth: isMobile ? '140px' : '200px' }}>
                <img
                  src={BharatConnectLogo}
                  alt="Bharat Connect Logo"
                  style={{ height: isMobile ? '45px' : '70px', objectFit: 'contain' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <TenthSection />
      <FourthSection />

      <RoeSection />
      <TestimonialSection title={
        <>
          <h2
            style={{
              color: "#37546D",
              fontSize: "clamp(2rem, 5vw, 41px)",
              margin: 0,
              fontWeight: 800,
              lineHeight: 1.2,
              textAlign: "center"
            }}
          >
            Real Partners. Real Impact. <span
              style={{
                background: "linear-gradient(90deg, #16b287, #2c9e7a)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: "clamp(2rem, 5vw, 48px)",

              }}
            >
              Real Smiles at the Last Mile
            </span>
          </h2>
          <p
            style={{
              color: "#1a2533",
              fontWeight: 500,
              lineHeight: 1.2,
              marginTop: 16
            }}
          >
            A platform that listens, supports, and empowers—making services simple, fast, and income-driven for every partner.  <br />
          </p>

          <h2
            style={{
              color: "#37546D",
              marginTop: "2rem",
              fontWeight: 800,
              lineHeight: 1.2,
              opacity: "0.1",
              marginBottom: "2rem"
            }}
          >
            What Our Partners Say
          </h2>

        </>
      }
        data={testimonials}
      />
      {/* <MediaCoverage /> */}
      {/* <AwardContainer /> */}

      {/* <AppDownloadSection/> */}
      <SevenSection />
    </>
  );
};

export default Home;